import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

// Api
import getTokensApi from '../../api/getTokens.api.auth';
import getUserInfoApi from '../../api/getUserInfo.api.auth';

// Components
import FullScreenLoader from '../../../layout/components/FullScreenLoader/FullScreenLoader';

// Context
import { useAuth } from '../../../contexts';

// Events
import forceAuthorizationEvent from '../../events/forceAuthorization.event.auth';

// Search
import searchRoute from '../../../pages/SearchPage/route';

// Loading
import loadingRoute from '../../../layout/pages/LoadingPage/route';

const PerformAuthContainer = ({ code, code_verifier }) => {
  const history = useHistory();
  const { signIn } = useAuth();

  useEffect(() => {
    const init = async () => {
      try {
        const { token } = await getTokensApi({
          code,
          code_verifier,
        });
        const user = await getUserInfoApi({ token });
        signIn({ token, user });
        history.replace(searchRoute());
      } catch (error) {
        history.replace(loadingRoute());
        forceAuthorizationEvent.publish();
      }
    };

    init();
  }, [code, code_verifier, history, signIn]);

  return <FullScreenLoader />;
};

PerformAuthContainer.propTypes = {
  code: PropTypes.string,
  code_verifier: PropTypes.string,
};

export default PerformAuthContainer;
